<template>
  <div :class="['input-container', inputClass]" :style="[inputStyle]">
    <textarea
      v-if="textarea"
      :id="id"
      class="form-control"
      :maxlength="maxlength"
      :value="displayText"
      :disabled="disabled"
      :readonly="readonly"
      :placeholder="placeholder"
      @input="handleInput"
      @keypress="handleKeyPress"
      @keyup.enter="onEnter"
      @blur="onBlur"
      @focus="onFocus"
    />
    <div v-else class="input-wrapper">
      <input
        :id="id"
        type="text"
        :class="['form-control', lengthIndicator ? 'padded' : '']"
        :maxlength="maxlength"
        :value="displayText"
        :disabled="disabled"
        :readonly="readonly"
        :placeholder="placeholder"
        @input="handleInput"
        @keypress="handleKeyPress"
        @keyup.enter="onEnter"
        @blur="onBlur"
        @focus="onFocus"
        @paste="onPaste"
      />
      <div v-if="value && suffix" class="suffix-container">
        <span
          class="suffix"
          :style="{
            left: 2 + String(this.value).length + 'ch',
          }"
        >
          {{ suffix }}
        </span>
      </div>
      <div v-if="lengthIndicator && maxlength" class="indicator">
        <span>{{ String(this.value).length }}/{{ maxlength }}</span>
      </div>
    </div>
    <span v-if="error" class="text-danger error-text">{{ error }}</span>
  </div>
</template>

<script>
export default {
  props: {
    id: String,
    value: [String, Number],
    placeholder: String,
    max: [String, Number],
    min: [String, Number],
    textarea: Boolean,
    type: {
      type: String,
      default: "text",
    },
    disabled: Boolean,
    readonly: Boolean,
    maxlength: [String, Number],
    lengthIndicator: Boolean,
    isRupiah: Boolean,
    suffix: String,
    error: String,
    inputClass: String,
    inputStyle: Object,
  },
  data() {
    return {
      displayText: "",
    };
  },
  mounted() {
    this.handleDisplay();
  },
  watch: {
    value() {
      this.handleDisplay();
    },
  },
  methods: {
    checkStartWithZero(val) {
      const reg = /^[1-9][0-9]*$/;
      return reg.test(val);
    },
    handleDisplay() {
      if (this.type === "number") {
        // if (!this.checkStartWithZero(this.value)) {
        //   return (this.displayText = "");
        // }
        if (this.isRupiah) {
          let parsedValue = this.filters.rupiah(this.value);
          if (this.value == 0) parsedValue = "Rp0";
          if (!String(this.value)) parsedValue = "";
          return (this.displayText = parsedValue);
        }
      }

      return (this.displayText = this.value);
    },
    handleInput(e) {
      const { value } = e.target;
      let final = value;

      if (this.type === "number") {
        if (this.isRupiah) {
          if (value == "0") this.displayText = "Rp0";
          if (value == "Rp") this.displayText = "";
          final = final.replaceAll(/[Rp|.]/g, "");
        }

        final = Number(final);
        // for clear value regular number
        if (value === "" || (!this.isRupiah && isNaN(value))) {
          final = "";
        }

        // for clear value rupiah number
        if (value === "Rp") {
          final = "";
        }

        if (this.max && final > Number(this.max)) {
          this.$emit("onChange", Number(this.max));
          return;
        }
        if (this.min && final < Number(this.min)) {
          if (final === 0) e.target.value = this.min;
          this.$emit("onChange", Number(this.min));
          return;
        }
      }

      this.$emit("onChange", final);
    },
    handleKeyPress(e) {
      if (this.type === "number" && this.max && this.value >= this.max) {
        e.preventDefault();
      }
      if (this.type === "number" && this.min && this.value < this.min) {
        e.preventDefault();
      }
      if (this.type === "number") {
        this.filters.handleNumberKeypress(e);
      }
    },
    onEnter(e) {
      this.$emit("onEnter", e);
    },
    onBlur(e) {
      this.$emit("onBlur", e);
    },
    onFocus(e) {
      this.$emit("onFocus", e);
    },
    onPaste(e) {
      if (this.type === "number") {
        let pasteValue = e.clipboardData.getData("text/plain");
        if (!/^\d+$/.test(pasteValue)) {
          const onlyNum = pasteValue.replace(/\D/g, "");
          e.target.value = onlyNum;
          this.$emit("onChange", Number(onlyNum));
          e.preventDefault()
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.input-container {
  display: flex;
  flex-direction: column;
}
.input-wrapper {
  position: relative;
  width: 100%;

  .form-control {
    height: 27.2px;
    font-size: inherit !important;
    font-weight: inherit;
    &.padded {
      padding-right: 35px;
    }
  }

  .suffix-container {
    pointer-events: none;
    position: absolute;
    inset: 0;
    overflow: hidden;
  }

  .suffix {
    position: absolute;
    top: 50%;
    left: 3ch;
    transform: translateY(-50%);
  }

  .indicator {
    position: absolute;
    top: 50%;
    right: 5px;
    transform: translateY(-50%);
    color: #cccccd;
  }
}

.error-text {
  margin-top: 4px;
  text-align: left;
}
</style>
